module.exports = __webpack_public_path__ + "img/Acceptance_delivery.28284763.jpg";